import React from "react";
import { useNavigate } from "react-router-dom";
import { GRAPH_TYPE } from "../../../constants/trendGraph/trendGraphType";
import { GraphSelector } from "../graphSelector";
import { CustomGraphSelector } from "../customGraph/graphSelector";
import { SEP_CHART_TYPE } from "../../../constants/trendGraph/sepLines";
import { ENGINE_CHART_TYPE } from "../../../constants/trendGraph/enginesLine";
import { chartSettingList } from "../trendPageCommonFunction";
import PropTypes from "prop-types";
import { ELECTRIC_TREND_TYPE } from "../../../constants/trendGraph/electricLines";
import { ADDITIONAL_ELECTRIC_TREND_TYPE } from "../../../constants/trendGraph/additionalElectricTrend";

export const DisplayChartsList = (props) => {
  const { 
    selectedGraph,
    vesselId,
    selectedChart,
    customCharts,
    isCreateCustomCharts,
    setIsCreateCustomCharts,
    customChartTitle,
    currentVessel,
  } = props;
  const navigate = useNavigate();
  const updateSelectedChart = (chart) => {
    navigate(`/trend/${selectedGraph}/${chart}/${vesselId}`);
  };
  const isSepVessel = currentVessel?.vesselType === "SEP";
  switch (selectedGraph) {
    case GRAPH_TYPE.CUSTOM:
      return (
        <CustomGraphSelector
          selectedChart={selectedChart}
          setSelectedChart={updateSelectedChart}
          chartList={customCharts}
          isCreateCustomCharts={isCreateCustomCharts}
          setIsCreateCustomCharts={setIsCreateCustomCharts}
          customChartTitle={customChartTitle}
        />
      );
    case GRAPH_TYPE.ELECTRIC:
      return (
        <GraphSelector
          selectedChart={selectedChart}
          chartType={isSepVessel ? ADDITIONAL_ELECTRIC_TREND_TYPE : ELECTRIC_TREND_TYPE}
          chartSettingList={chartSettingList(selectedGraph, isSepVessel)}
          setSelectedChart={updateSelectedChart}
          vesselId={vesselId}
        />
      );
    case GRAPH_TYPE.ENGINE:
      return (
        <GraphSelector
          selectedChart={selectedChart}
          chartType={ENGINE_CHART_TYPE}
          chartSettingList={chartSettingList(selectedGraph)}
          setSelectedChart={updateSelectedChart}
          vesselId={vesselId}
        />
      );
    case GRAPH_TYPE.SEP:
      return (
        <GraphSelector
          selectedChart={selectedChart}
          chartType={SEP_CHART_TYPE}
          chartSettingList={chartSettingList(selectedGraph)}
          setSelectedChart={updateSelectedChart}
          vesselId={vesselId}
        />
      );
  }
};

DisplayChartsList.propTypes = {
  vesselId: PropTypes.string,
  selectedGraph: PropTypes.string,
  selectedChart: PropTypes.string,
  customCharts: PropTypes.array,
  isCreateCustomCharts: PropTypes.bool,
  setIsCreateCustomCharts: PropTypes.func,
  customChartTitle: PropTypes.string,
  currentVessel: PropTypes.object,
}